// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___kwu5a","skeleton-loading":"styles__skeleton-loading___3k49T","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___2SeMw","greenBackgroundSkeleton":"styles__greenBackgroundSkeleton___2bamj","skeleton-green":"styles__skeleton-green___3UcTI","skeleton-loader-gradient":"styles__skeleton-loader-gradient___x7MB9","skeletonText":"styles__skeletonText___3w3_D","skeleton-loading-green":"styles__skeleton-loading-green___swZm7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/CustomerGreetings/styles.css
// module id = 2504
// module chunks = 0